import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageTitle } from '../../utils/title';
import Breadcrumb from '../../components/Breadcrumb';
import './CaseStudies.scss';
import caseStudy1 from '../../assets/images/case-studies/case_study_1.png';
import caseStudy2 from '../../assets/images/case-studies/case_study_2.png';
import { trackEvent } from '../../utils/analytics';

const CaseStudies = () => {
  useEffect(() => {
    setPageTitle('Case Studies');
  }, []);

  const breadcrumbItems = [
    { path: '/', label: 'Home' },
    { path: '/case-studies', label: 'Case Studies' },
  ];

  const handleCaseStudyClick = studyName => {
    trackEvent('Case Studies', 'View Case Study', studyName);
  };

  return (
    <div className="case-studies-page">
      <Breadcrumb items={breadcrumbItems} />
      <section className="page-header">
        <div className="container">
          <h1 className="page-header__title">Case Studies</h1>
        </div>
      </section>

      <section className="case-studies-section section section--light">
        <div className="container">
          <div className="case-studies__grid">
            {/* Case Study 1 */}
            <div className="case-study-card">
              <div className="case-study-card__image">
                <img src={caseStudy1} alt="FinTech Platform Architecture Diagram" />
              </div>
              <div className="case-study-card__content">
                <Link
                  to="/case-studies/fintech-platform"
                  className="case-study-card__title"
                  onClick={() => handleCaseStudyClick('FinTech Platform')}
                >
                  FinTech Platform
                </Link>
                <div className="case-study-card__keywords">
                  <span className="keyword">AWS ECS</span>
                  <span className="keyword">Data Pipelines</span>
                  <span className="keyword">SSO Integration</span>
                  <span className="keyword">Financial Analytics</span>
                </div>
                <p className="case-study-card__description">
                  FinTech Platform for Data Analysis and Financial Reporting that Revolutionizes
                  Portfolio Management in the B2B Energy Sector
                </p>
                <Link
                  to="/case-studies/fintech-platform"
                  className="btn btn--primary"
                  onClick={() => handleCaseStudyClick('FinTech Platform')}
                >
                  View Case Study
                </Link>
              </div>
            </div>

            {/* Case Study 2 */}
            <div className="case-study-card">
              <div className="case-study-card__image">
                <img src={caseStudy2} alt="Human Data ML/AI Platform Architecture Diagram" />
              </div>
              <div className="case-study-card__content">
                <Link
                  to="/case-studies/ml-ai-platform"
                  className="case-study-card__title"
                  onClick={() => handleCaseStudyClick('ML/AI Platform')}
                >
                  Human Data ML/AI Platform
                </Link>
                <div className="case-study-card__keywords">
                  <span className="keyword">ML/AI Infrastructure</span>
                  <span className="keyword">Cloud Security</span>
                  <span className="keyword">SOC 2 Compliance</span>
                  <span className="keyword">HIPAA Compliance</span>
                </div>
                <p className="case-study-card__description">
                  Scalable Cloud Infrastructure Supporting ML/AI Pipelines for a Bio-Mechanical
                  Technology Startup, with a Focus on Information Security
                </p>
                <Link
                  to="/case-studies/ml-ai-platform"
                  className="btn btn--primary"
                  onClick={() => handleCaseStudyClick('ML/AI Platform')}
                >
                  View Case Study
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CaseStudies;
